import { render, staticRenderFns } from "./ExpanderText.vue?vue&type=template&id=32af2c7e&scoped=true&"
import script from "./ExpanderText.vue?vue&type=script&lang=js&"
export * from "./ExpanderText.vue?vue&type=script&lang=js&"
import style0 from "./ExpanderText.vue?vue&type=style&index=0&id=32af2c7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af2c7e",
  null
  
)

export default component.exports